var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDespairSadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4978 68C52.9981 68 67.9955 53.0015 67.9955 34.5C67.9955 15.9985 52.9981 1 34.4978 1C15.9975 1 1 15.9985 1 34.5C1 53.0015 15.9975 68 34.4978 68Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7453 8.3457C26.7453 8.3457 29.0183 16.6609 21.8283 21.2312C21.8283 21.2312 15.7867 25.0239 8.93164 19.6041C8.93164 19.6041 21.7206 22.2362 26.7453 8.3457Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4066 40.5532C27.4767 40.5532 30.7761 36.0108 30.7761 30.4074C30.7761 24.8041 27.4767 20.2617 23.4066 20.2617C19.3365 20.2617 16.0371 24.8041 16.0371 30.4074C16.0371 36.0108 19.3365 40.5532 23.4066 40.5532Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7473 37.1555C26.7823 37.1555 28.432 34.8843 28.432 32.0826C28.432 29.281 26.7823 27.0098 24.7473 27.0098C22.7122 27.0098 21.0625 29.281 21.0625 32.0826C21.0625 34.8843 22.7122 37.1555 24.7473 37.1555Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.677 8.3457C41.677 8.3457 39.4039 16.6609 46.594 21.2312C46.594 21.2312 52.6356 25.0239 59.4907 19.6041C59.4907 19.6041 46.7017 22.2362 41.677 8.3457Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.014 40.5532C49.0841 40.5532 52.3836 36.0108 52.3836 30.4074C52.3836 24.8041 49.0841 20.2617 45.014 20.2617C40.9439 20.2617 37.6445 24.8041 37.6445 30.4074C37.6445 36.0108 40.9439 40.5532 45.014 40.5532Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6731 37.1555C45.7081 37.1555 47.3578 34.8843 47.3578 32.0826C47.3578 29.281 45.7081 27.0098 43.6731 27.0098C41.638 27.0098 39.9883 29.281 39.9883 32.0826C39.9883 34.8843 41.638 37.1555 43.6731 37.1555Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7617 55.9156C27.7617 52.1947 30.7765 49.1797 34.4972 49.1797C38.2178 49.1797 41.2326 52.1947 41.2326 55.9156",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7617 55.9156C27.7617 52.1947 30.7765 49.1797 34.4972 49.1797C38.2178 49.1797 41.2326 52.1947 41.2326 55.9156",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7792 40.5547C45.7792 40.5547 38.8404 52.0763 45.7792 52.0763C52.7181 52.0763 45.7792 40.5547 45.7792 40.5547Z",
    fill: "#00ADEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9413 34.7988C51.9413 34.7988 45.0025 46.3204 51.9413 46.3204C58.8802 46.3204 51.9413 34.7988 51.9413 34.7988Z",
    fill: "#00ADEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDespairSadIcon);
export default __webpack_public_path__ + "static/media/despair-sad-icon.a6dea298c8eac1b0827c0c67373bcff1.svg";
export { ForwardRef as ReactComponent };